import { MEMBERSHIP_SKUS } from '@/app/[locale]/store/_consts';
import type { RefreshCartResult } from '@/queries/RefreshCart';

const getExistingMembership = (refreshCart: RefreshCartResult | undefined) => {
  return refreshCart?.cart?.refreshCart.cart?.lineItems?.find((lineItem) => {
    const sku = lineItem?.skuCode;
    if (!sku) return false;
    return MEMBERSHIP_SKUS.includes(sku);
  });
};

export default getExistingMembership;
